import { fromFetch } from 'rxjs/fetch';
import { AuthHeaders } from '../../models/auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { accountsEnvironment } from './accounts-environment';
import { metricLogResponseSchema } from './schemas/metric-logs.schema';

export function postDeviceLogs(
  accountId: string,
  deviceId: string,
  startDate: Date,
  endDate: Date
) {
  return fromFetch(
    new Request(accountsEnvironment.deviceLogsUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
      body: JSON.stringify({
        accountId,
        deviceId,
        startDate,
        endDate,
      }),
    })
  ).pipe(selectData(metricLogResponseSchema));
}
